// extracted by mini-css-extract-plugin
module.exports = {"goldButton":"Style_goldButton__29hRP","fLogo":"Style_fLogo__1gIf-"};